(function () {

  function initSection(section) {
    var sectionId = section.dataset.ctabId;
    if (!sectionId) return;

    /* ─────────────────────────────────────────────
       FILTER ARROW LOGIC
    ───────────────────────────────────────────── */
    var filtersEl  = document.getElementById('ctab-filters-' + sectionId);
    var filterPrev = document.getElementById('ctab-filter-prev-' + sectionId);
    var filterNext = document.getElementById('ctab-filter-next-' + sectionId);

    function updateFilterArrows() {
      if (!filtersEl || !filterPrev || !filterNext) return;
      var atStart = filtersEl.scrollLeft <= 1;
      var atEnd   = filtersEl.scrollLeft + filtersEl.clientWidth >= filtersEl.scrollWidth - 1;
      filterPrev.style.opacity       = atStart ? '0.3' : '1';
      filterPrev.style.pointerEvents = atStart ? 'none' : 'auto';
      filterNext.style.opacity       = atEnd   ? '0.3' : '1';
      filterNext.style.pointerEvents = atEnd   ? 'none' : 'auto';
    }

    if (filterPrev) filterPrev.addEventListener('click', function () { filtersEl.scrollBy({ left: -160, behavior: 'smooth' }); });
    if (filterNext) filterNext.addEventListener('click', function () { filtersEl.scrollBy({ left:  160, behavior: 'smooth' }); });
    if (filtersEl)  filtersEl.addEventListener('scroll', updateFilterArrows, { passive: true });

    /* ─────────────────────────────────────────────
       CAROUSEL LOGIC
    ───────────────────────────────────────────── */
    function isMobileOrTablet() { return window.innerWidth <= 991; }

    function updateCarouselArrows(panel, idx, maxIdx) {
      var arrowsWrap = panel.querySelector('.ctab-carousel-arrows');
      var prevBtn = panel.querySelector('.ctab-arrow--prev');
      var nextBtn = panel.querySelector('.ctab-arrow--next');
      if (!prevBtn || !nextBtn) return;
      if (maxIdx <= 0) {
        if (arrowsWrap) arrowsWrap.style.display = 'none';
        return;
      }
      if (arrowsWrap) arrowsWrap.style.display = '';
      prevBtn.style.opacity       = idx <= 0      ? '0.3' : '1';
      prevBtn.style.pointerEvents = idx <= 0      ? 'none' : 'auto';
      nextBtn.style.opacity       = idx >= maxIdx ? '0.3' : '1';
      nextBtn.style.pointerEvents = idx >= maxIdx ? 'none' : 'auto';
    }

    function initCarousel(panel) {
      var wrap  = panel.querySelector('.ctab-carousel-wrap');
      var track = panel.querySelector('.ctab-track');
      if (!wrap || !track) return;

      var currentIdx = 0;

      function getCardWidth() {
        var c = track.querySelector('a.ctab-card');
        if (!c) return 0;
        var gap = parseInt(window.getComputedStyle(track).gap) || 16;
        return c.offsetWidth + gap;
      }

      function getVisibleCount() { return window.innerWidth <= 767 ? 1 : 2; }

      function getMaxIdx() {
        return Math.max(0, track.querySelectorAll('a.ctab-card').length - getVisibleCount());
      }

      function goTo(n) {
        var max = getMaxIdx();
        currentIdx = Math.max(0, Math.min(n, max));
        track.style.transform = 'translateX(-' + (currentIdx * getCardWidth()) + 'px)';
        updateCarouselArrows(panel, currentIdx, max);
      }

      var prevBtn = panel.querySelector('.ctab-arrow--prev');
      var nextBtn = panel.querySelector('.ctab-arrow--next');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIdx + 1); });

      var touchStartX = 0, touchStartY = 0;
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        var dx = touchStartX - e.changedTouches[0].clientX;
        var dy = Math.abs(touchStartY - e.changedTouches[0].clientY);
        if (Math.abs(dx) > 40 && Math.abs(dx) >= dy) goTo(currentIdx + (dx > 0 ? 1 : -1));
      }, { passive: true });

      panel._ctabReset = function () {
        currentIdx = 0;
        track.style.transition = 'none';
        track.style.transform  = 'translateX(0)';
        requestAnimationFrame(function () {
          track.style.transition = 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)';
        });
        updateCarouselArrows(panel, 0, getMaxIdx());
      };

      updateCarouselArrows(panel, 0, getMaxIdx());
    }

    section.querySelectorAll('.ctab-panel').forEach(initCarousel);

    /* ─────────────────────────────────────────────
       TAB PILL SWITCHING
    ───────────────────────────────────────────── */
    var viewAllBtn = document.getElementById('ctab-view-all-' + sectionId);

    section.querySelectorAll('.ctab-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        section.querySelectorAll('.ctab-pill').forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');

        if (isMobileOrTablet()) {
          this.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        var targetId = this.getAttribute('data-panel');
        section.querySelectorAll('.ctab-panel').forEach(function (panel) {
          if (panel.id === targetId) {
            panel.classList.add('active');
            if (panel._ctabReset) panel._ctabReset();
          } else {
            panel.classList.remove('active');
          }
        });

        updateFilterArrows();

        if (viewAllBtn) {
          var colUrl = this.getAttribute('data-collection-url');
          if (colUrl) viewAllBtn.setAttribute('href', colUrl);
        }
      });
    });

    /* ─────────────────────────────────────────────
       RESIZE HANDLER
    ───────────────────────────────────────────── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateFilterArrows();
        section.querySelectorAll('.ctab-panel').forEach(function (panel) {
          if (panel._ctabReset) panel._ctabReset();
        });
      }, 120);
    });

    updateFilterArrows();
  }

  /* ─────────────────────────────────────────────
     SWATCH CLICK (global helper)
  ───────────────────────────────────────────── */
  window.ctabSwatchClick = function (event) {
    event.preventDefault();
    event.stopPropagation();
    var btn  = event.currentTarget;
    var card = btn.closest('.ctab-card');
    if (!card) return;

    btn.closest('.ctab-card__swatches').querySelectorAll('.ctab-swatch').forEach(function (s) { s.classList.remove('is-active'); });
    btn.classList.add('is-active');

    var img = card.querySelector('.ctab-card__img');
    if (img && btn.dataset.image) img.src = btn.dataset.image;

    var atc = card.querySelector('.ctab-card__atc');
    if (atc && btn.dataset.variantId) {
      atc.setAttribute('onclick', "ctabAddToCart(event,'" + btn.dataset.variantId + "')");
    }
  };

  /* ─────────────────────────────────────────────
     ADD TO CART (global helper)
  ───────────────────────────────────────────── */
  window.ctabAddToCart = function (event, variantId) {
    event.preventDefault();
    event.stopPropagation();
    var btn  = event.currentTarget;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      btn.textContent = '✓ Added!';
      setTimeout(function () { btn.textContent = orig; }, 1800);
    })
    .catch(function () { btn.textContent = orig; });
  };

  /* ─────────────────────────────────────────────
     AUTO-INIT
  ───────────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.ctab-section[data-ctab-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.ctab-section[data-ctab-id]');
    if (s) initSection(s);
  });

})();
